<div class="private">
  <ul class="list-unstyled">
    <virtual-scroller #scroll [items]="contacts" (vsChange)="scrollEvent = $event" [class.max-height]="contacts.length > 5" [class.min-height]="contacts.length > 0 && contacts.length <= 5" [class.no-height]="contacts.length == 0">
      <li class="recipient-item" *ngFor="let item of scroll.viewPortItems, let i = index">
        <i class="icon fa fa-address-book"></i>
        <span *ngIf="item.surname || item.othername; else no_name">
          {{ item.surname }} {{ item.othername }}
        </span>
        <ng-template #no_name>
          (no name)
        </ng-template>
        <br>
        <small>{{ item.mobile }}</small>

        <span *ngIf="showDelete" class="fa fa-trash text-danger recipient-delete pull-right" (click)="removeRecipient(i + scrollEvent?.startIndex)"></span>
      </li>
    </virtual-scroller>

    <li class="recipient-item empty" *ngIf="!contacts.length">
      <i class="icon fa fa-info-circle"></i>
      No recipients have been added
    </li>
  </ul>
</div>
